import { ContractStatus } from '../types';
export const isProcessingStatus = (status) => {
    return [
        ContractStatus.SYNC_CONTRACT_DATA,
        ContractStatus.PENDING,
        ContractStatus.SYNC_BENEFICIARIES_PARTNER,
    ].includes(status);
};
export const getStatusDate = (contract) => {
    if (!contract)
        return null;
    const { status } = contract;
    if (status === ContractStatus.CREATED) {
        return contract.createdAt ?? contract.startDate ?? null;
    }
    if (isProcessingStatus(status) || status === ContractStatus.ACTIVE) {
        return contract.startDate ?? null;
    }
    return null;
};
export const getCreationDate = (contract) => {
    if (!contract)
        return null;
    return contract.createdAt ?? contract.startDate ?? null;
};
export const formatContractDate = (dateString) => {
    if (!dateString)
        return null;
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime()))
            return null;
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}/${month}/${year}`;
    }
    catch {
        return null;
    }
};
export const formatContractDateShort = (dateString) => {
    if (!dateString)
        return null;
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime()))
            return null;
        const day = date.getDate();
        const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    }
    catch {
        return null;
    }
};
